import React from 'react';
import { Input } from 'reactstrap';
import { Controller, FieldValues } from 'react-hook-form';
import 'react-datepicker/dist/react-datepicker.css';
import { ICustomTextProps } from 'models/Form';
import './FormComponents.css';

export function ControlledCheckbox<T extends FieldValues>({
  fieldName,
  control,
  label,
  placeholder,
  description,
  rules,
  readonly,
}: ICustomTextProps<T>) {
  return (
    <Controller
      name={fieldName}
      control={control}
      rules={rules || {}}
      render={({ field, fieldState, formState }) => {
        const isValid: boolean =
          !fieldState.invalid && (fieldState.isTouched || formState.isSubmitted) && !readonly;
        const isInvalid: boolean =
          fieldState.invalid && (fieldState.isTouched || formState.isSubmitted) && !readonly;
        return (
          <>
            <span>{label}</span>
            <div className={'d-flex flex-row'}>
              <Input
                type="checkbox"
                ref={field.ref}
                value={field.value as string}
                readOnly={readonly}
                valid={isValid}
                invalid={isInvalid}
                name={field.name}
                onBlur={field.onBlur}
                onChange={field.onChange}
                disabled={readonly}
                className={'sms-consent-checkbox'}
                checked={field.value as boolean}
              />
              <div className={'ps-3 d-flex flex-column gap-2'}>
                <span>{placeholder}</span>
                {description && (
                  <span>
                    <i>{description}</i>
                  </span>
                )}
              </div>
            </div>
          </>
        );
      }}
    />
  );
}
